export interface EnvironmentConfig {
  apiBaseUrlCore: string;
  apiBaseUrlIntegration: string;
  environment: 'development' | 'staging' | 'production';
  enableDevTools: boolean;
  logLevel: 'debug' | 'info' | 'warn' | 'error';
  senderEmail: string;
}

export const getEnvironmentConfig = (): EnvironmentConfig => {
  console.log("VITE_API_BASE_URL_CORE : ",import.meta.env.VITE_API_BASE_URL_CORE)
  console.log("VITE_API_BASE_URL_INTEGRATION : ",import.meta.env.VITE_API_BASE_URL_INTEGRATION)
  return {
    apiBaseUrlCore: import.meta.env.VITE_API_BASE_URL_CORE,
    apiBaseUrlIntegration: import.meta.env.VITE_API_BASE_URL_INTEGRATION,
    environment: (import.meta.env.NODE_ENV as any) || 'development',
    enableDevTools: import.meta.env.NODE_ENV !== 'production',
    logLevel: (import.meta.env.VITE_LOG_LEVEL as EnvironmentConfig['logLevel']) || 'info',
    senderEmail: import.meta.env.VITE_SENDER_EMAIL || 'no-reply@verifytoday.com',
  };
};
